import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { setClock } from "@tsi/domain";

import "./globals.css";
import { MOCK_NOW } from "@/services/mock";
import { SessionProvider } from "@/features/auth";
import { AppRoutes } from "./routes";

// As telas da V1 leem da API. Só as escondidas da POC (Painel, Clientes, Vendas, Compras, Análises) e
// o sininho/busca do cabeçalho ainda usam o mock, congelado em MOCK_NOW. Remover junto com o mock.
setClock(() => new Date(MOCK_NOW));

const container = document.getElementById("root");
if (!container) throw new Error("Elemento #root não encontrado.");

createRoot(container).render(
  <React.StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <AppRoutes />
      </SessionProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
